// extracted by mini-css-extract-plugin
export var root = "QuickView-module--root--QRCZM";
export var titleContainer = "QuickView-module--titleContainer--l8zIZ";
export var contentContainer = "QuickView-module--contentContainer--XtQPu";
export var productContainer = "QuickView-module--productContainer--6JnFX";
export var productName = "QuickView-module--productName--2KrOv";
export var price = "QuickView-module--price--bRQF3";
export var productImageContainer = "QuickView-module--productImageContainer--GGZzd";
export var sectionContainer = "QuickView-module--sectionContainer--qFFc2";